import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./EditPinLevelModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import CircleCheckbox from "shared/CircleCheckbox";
import { OptionsDropdown } from "DreamStream/Shared/OptionsDropdown/OptionsDropdown";

/**
 * Interactive component. Modal used for updating the pin level.
 */

export function EditPinLevelModal({
  isOpen,
  onClose,
  onClick,
  foregoSync,
  noRefresh,
}) {
  const [permission, setPermission] = useState("3 - Emerald");
  const [autoSync, setAutoSync] = useState(foregoSync);
  const [noRefreshSync, setNoRefreshSync] = useState(noRefresh);

  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="OVERRIDE PIN"
        closeBtn="none"
        className={styles.modal}
      >
        <div className={styles.contentContainer}>
          <div className={styles.contentDiv}>
            <p className={styles.contentText}>
              Override an IBO's pin level so they're treated as a different pin
              on Dreamstream.
            </p>
            <p className={styles.contentText}>
              This change will affect Downline membership
            </p>
          </div>

          <div className={styles.permissionDiv}>
            <label className={styles.label}>Pin Level:</label>
            <OptionsDropdown
              options={[
                "1 - Associate IBO",
                "2 - Platinum",
                "3 - Emerald ",
                "4 - Diamond",
              ]}
              openedPlaceholder={"Select"}
              placeholder={permission === "" ? "Select" : permission}
              onChange={(option) => {
                setPermission(option);
              }}
            />
          </div>

          <div className={styles.circleboxContainer}>
            <CircleCheckbox
              checked={autoSync}
              name="Forego automatic sync adding plugin"
              onChange={() => {
                setAutoSync(!autoSync);
              }}
            />
          </div>
          <div className={styles.circleboxContainer}>
            <CircleCheckbox
              checked={noRefreshSync}
              name="No refresh: sync without refreshing LOS info"
              onChange={() => {
                setNoRefreshSync(!noRefreshSync);
              }}
            />
          </div>
        </div>
        <div className={styles.btnContainer}>
          <ModalActionBar
            children={
              <div className={styles.btnDiv}>
                <button
                  type="button"
                  className={styles.cancelBtn}
                  onClick={onClose}
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className={styles.syncBtn}
                  onClick={onClick}
                >
                  SYNC
                </button>
              </div>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

EditPinLevelModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when create all is clicked
   */
  onClick: PropTypes.func,
  /**
   * True if forego automatic sync is checked
   */
  foregoSync: PropTypes.bool,
  /**
   * True if no refresh is checked
   */
  noRefresh: PropTypes.bool,
};
